import {ajax_get} from "./index";

export const getALLMenu = (data) => ajax_get('/museummenu', data);
export const getInfo = (data) => ajax_get('/museumfillinfo', data);
export const getbaseInfo = (data) => ajax_get('/museumbaseinfo', data);
export const savebaseingo = (data) => ajax_get('/museumbaseinfosave', data);
export const otherfiles = (data)=>ajax_get('otherfilelist', data)
export const getSuggest = (data)=>ajax_get('proposallist', data)
